<template>
  <div>
    <snackbar />
    <router-view />

    <!-- Update Notification Dialog -->
    <v-dialog
      v-model="updateDialog"
      max-width="290"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Aggiornamento Disponibile
        </v-card-title>
        <v-card-text class="text-center">
          Nuova versione installata. <br> Ricarica per aggiornare
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="reloadPage"
          >
            Ricarica
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Snackbar from '@/components/base/Snackbar'
  import { mapActions } from 'vuex'
  import Config from '@/config.js'

  export default {
    name: 'App',
    components: { Snackbar },

    data () {
      return {
        appver: Config.appver,
        isInactive: false,
        userActivityThrottlerTimeout: null,
        userActivityTimeout: null,
        INACTIVE_USER_TIME_THRESHOLD: (1 * 60 * 60 * 1000), // 1 ore in millesimi di secondo
        USER_ACTIVITY_THROTTLER_TIME: 1000,
        updateDialog: false,
      }
    },

    beforeMount () {
      // listen mouse ebvent to maintain live session
      this.activateActivityTracker()
    },

    beforeDestroy () {
      this.deactivateActivityTracker()
    },
    created () {
      navigator.serviceWorker.addEventListener('message', event => {
        if (event.data && event.data.type === 'UPDATE_AVAILABLE') {
          this.updateDialog = true
        }
      })
    },
    methods: {
      ...mapActions([
        'logout',
      ]),
      activateActivityTracker () {
        window.addEventListener('mousemove', this.userActivityThrottler)
        window.addEventListener('scroll', this.userActivityThrottler)
        window.addEventListener('keydown', this.userActivityThrottler)
        window.addEventListener('resize', this.userActivityThrottler)
      },

      deactivateActivityTracker () {
        window.removeEventListener('mousemove', this.userActivityThrottler)
        window.removeEventListener('scroll', this.userActivityThrottler)
        window.removeEventListener('keydown', this.userActivityThrottler)
        window.removeEventListener('resize', this.userActivityThrottler)
      },

      resetUserActivityTimeout () {
        clearTimeout(this.userActivityTimeout)

        this.userActivityTimeout = setTimeout(() => {
          this.userActivityThrottler()
          this.inactiveUserAction()
        }, this.INACTIVE_USER_TIME_THRESHOLD)
      },

      userActivityThrottler () {
        if (this.isInactive) {
          this.isInactive = false
        }

        if (!this.userActivityThrottlerTimeout) {
          console.log('utente attivato')
          this.userActivityThrottlerTimeout = setTimeout(() => {
            this.resetUserActivityTimeout()
            clearTimeout(this.userActivityThrottlerTimeout)
            this.userActivityThrottlerTimeout = null
          }, this.USER_ACTIVITY_THROTTLER_TIME)
        }
      },

      inactiveUserAction () {
        console.log('utente disattivato')
        this.isInactive = true
        if (sessionStorage.getItem('logged') === 'true') {
          this.$store.commit('setSnack', { message: 'Session Expired', color: '#c54747d4', timeout: 1500 })
          this.logout()
        }
      },
      reloadPage () {
        this.updateDialog = false
        window.location.reload(true)
      },
    },

  }
</script>
<style scoped>
.container{
  padding:0px;
  }
</style>
